module.exports = __webpack_public_path__ + "static/img/about1_4.3f3c3da0.png";